module.exports = __webpack_public_path__ + "static/media/GESSTwoMedium-Medium.cc5b7085.ttf";